import styled, { css } from 'styled-components';

export const LogoWatermark = styled.div`
	${({ theme }) => css`
		position: absolute;
		height: auto;
		top: 58px;
		left: 50%;
		transform: translatex(-50%);
		width: 192px;

		@media ${theme.screens.screenGTS} {
			top: 134px;
			left: 50%;
			transform: translatex(-50%);
			width: 360px;
		}
	`};
`;

export const Logo = styled.img`
	opacity: 1;
	width: 100%;
`;

